// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__-m6I-","toastIn":"Toast_toastIn__o0Ukz","text":"Toast_text__9gvLJ","close":"Toast_close__8XFR8","success":"Toast_success__hqwzj","error":"Toast_error__JSaZU"};